import { IsolatedCoroutineScopensqylcikdcw7 as IsolatedCoroutineScope } from '../../../kotlin-js/js/coroutines/internal/IsolatedCoroutineScope.mjs';
import { CoroutineStart_UNDISPATCHED_getInstance3vhik5zct4e74 as CoroutineStart_UNDISPATCHED_getInstance } from '../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function runIsolatedJob(block) {
  var job = launch(IsolatedCoroutineScope(), VOID, CoroutineStart_UNDISPATCHED_getInstance(), block);
  return Job$cancel$ref(job);
}
function Job$cancel$ref(p0) {
  return () => {
    p0.dx();
    return Unit_instance;
  };
}
//region block: exports
export {
  runIsolatedJob as runIsolatedJob3cgv8kybs77yh,
};
//endregion

//# sourceMappingURL=runIsolatedJob.mjs.map
